import React from 'react';
import { Switch, Route } from 'react-router-dom';

import routeConfig from './routeConfig';

class Routes extends React.Component {
  renderRoute = ({ routes, routeComponent, ...cfg }) => {
    const RouteComponent = routeComponent || Route;
    if (routes) {
      const Component = cfg.component;
      return (
        <RouteComponent
          key={cfg.path || '404'}
          {...cfg}
          component={null}
          render={() => <Component>{routes.map(this.renderRoute)}</Component>}
        />
      );
    } else {
      return <RouteComponent key={cfg.path || '404'} {...cfg} />;
    }
  };

  render() {
    return <Switch>{routeConfig.map(this.renderRoute)}</Switch>;
  }
}

export default Routes;
